// Module
var code = `<template>
  <require from="./portfolio-overview-chart-new-widget.scss"></require>

  <div class="portfolio-overview-chart-new-widget" mdc-size.bind="size">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <div show.bind="!loading && !error" class="portfolio-overview-chart-new-widget__chart" element.ref="chart"></div>
    <div show.bind="!loading && !error" class="portfolio-overview-chart-new-widget__grid" perfect-scrollbar>
      <div>
        <div class="header">Type</div>
        <div class="header numeric">Estimated</div>
        <div class="header numeric">Costprice</div>
        <div class="header numeric">Profit/Loss</div>
        <template repeat.for="r of data">
          <div class="cell first-column">
            <div class="marker" css="--marker-colour: \${r.colour}">\${r.group} \${r.percentage | numericFormatter:'0,0'}%</div>
            <div class="mandate" if.bind="showMandates">(mandate \${r.mandate | numericFormatter:'0,0'}%)</div>
          </div>
          <div class="numeric cell">\${r.estimatedValue | numericFormatter:'0,0'}</div>
          <div class="numeric cell">\${r.costPrice | numericFormatter:'0,0'}</div>
          <div class="numeric cell last-column">\${r.profitLossYearToDate | numericFormatter:'0,0'}</div>
        </template>
      </div>
    </div>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="portfolio-overview-chart-new-widget__error">
      \${error.message}</message>
  </div>
</template>
`;
// Exports
export default code;